import React from 'react'
import { useParams } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import RouteContainer from 'src/components/App/RouteContainer'

const DepartmentReadonlyForm = React.lazy(() => loadComponent('orga', 'DepartmentReadOnlyForm'))

export function DepartmentDetailsRoute() {
    const params = useParams()

    return (
        <RouteContainer>
            <DepartmentReadonlyForm departmentId={params._id} />
        </RouteContainer>
    )
}
